/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Onsite_1Inputs */

const en_svr_guidance_onsite_1 = /** @type {(inputs: Svr_Guidance_Onsite_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What work have you done?`)
};

const ja_svr_guidance_onsite_1 = /** @type {(inputs: Svr_Guidance_Onsite_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのような作業を行いましたか？`)
};

const fr_svr_guidance_onsite_1 = /** @type {(inputs: Svr_Guidance_Onsite_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels travaux avez-vous effectués ?`)
};

const de_svr_guidance_onsite_1 = /** @type {(inputs: Svr_Guidance_Onsite_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Arbeiten haben Sie durchgeführt?`)
};

/**
* | output |
* | --- |
* | "What work have you done?" |
*
* @param {Svr_Guidance_Onsite_1Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_onsite_1 = /** @type {((inputs?: Svr_Guidance_Onsite_1Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Onsite_1Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_onsite_1(inputs)
	if (locale === "ja") return ja_svr_guidance_onsite_1(inputs)
	if (locale === "fr") return fr_svr_guidance_onsite_1(inputs)
	return de_svr_guidance_onsite_1(inputs)
});